import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types'

export default function MySteps({ classNameBody, formSteps }) {
  const steps = formSteps

  return (
    <nav aria-label="Progress" className={`${classNameBody}`}>
      <ol
        className={`flex flex-wrap divide-gray-300 rounded-md border border-gray-300 ${
          steps.length > 3 && 'divide-y md:divide-y-0'
        }`}
      >
        {steps.map((step, stepIdx) => (
          <li
            className={`${
              steps.length > 3 && 'last:w-full md:last:w-auto'
            } relative md:flex`}
            key={step.name}
          >
            {step.status === 'complete' ? (
              <a className="group flex w-full items-center" href={step.href}>
                <span className="flex items-center p-2 text-sm font-medium">
                  <span
                    className={
                      'flex h-7 w-7 flex-shrink-0 items-center' +
                      ' justify-center rounded-full bg-primary group-hover:bg-primary'
                    }
                  >
                    <FontAwesomeIcon
                      aria-hidden="true"
                      className="h-6 w-6 text-white"
                      icon={faCheck}
                    />
                  </span>
                  <span className="mx-2 text-sm font-medium text-gray-900">
                    {step.name}
                  </span>
                </span>
              </a>
            ) : step.status === 'current' ? (
              <a
                aria-current="step"
                className="flex items-center p-2 text-sm font-medium"
                href={step.href}
              >
                <span
                  className={
                    'flex h-7 w-7 flex-shrink-0 items-center justify-center' +
                    ' rounded-full border-2 border-primary'
                  }
                >
                  <span className="text-primary">{stepIdx + 1}</span>
                </span>
                <span className="mx-2 text-sm font-medium text-primary">
                  {step.name}
                </span>
              </a>
            ) : (
              <a className="group flex items-center" href={step.href}>
                <span className="flex items-center p-2 text-sm font-medium">
                  <span
                    className={
                      'flex h-7 w-7 flex-shrink-0 items-center' +
                      ' justify-center rounded-full border-2 border-gray-300 group-hover:border-gray-400'
                    }
                  >
                    <span className="text-gray-500 group-hover:text-gray-900">
                      {stepIdx + 1}
                    </span>
                  </span>
                  <span className="mx-2 text-sm font-medium text-gray-500 group-hover:text-gray-900">
                    {step.name}
                  </span>
                </span>
              </a>
            )}

            {stepIdx !== steps.length - 1 ? (
              <>
                {/* Arrow separator for lg screens and up */}
                <div
                  aria-hidden="true"
                  className="absolute right-0 top-0 block h-full w-5"
                >
                  <svg
                    className="h-full w-full text-gray-300"
                    fill="none"
                    preserveAspectRatio="none"
                    viewBox="0 0 22 80"
                  >
                    <path
                      d="M0 -2L20 40L0 82"
                      stroke="currentcolor"
                      strokeLinejoin="round"
                      vectorEffect="non-scaling-stroke"
                    />
                  </svg>
                </div>
              </>
            ) : null}
          </li>
        ))}
      </ol>
    </nav>
  )
}

MySteps.propTypes = {
  classNameBody: PropTypes.string,
  formSteps: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      href: PropTypes.string,
      status: PropTypes.oneOf(['complete', 'current', 'upcoming']).isRequired,
    })
  ).isRequired,
}
